import { Box, TextareaV3 } from "@drone-js/core";
import { getAgoda } from "libs/analytics/functions/agoda.homes";
import type { FunctionComponent } from "react";

export interface ErrorStack {
    instance: Error;
}

export const ErrorStackRenderer: FunctionComponent<ErrorStack> = ({ instance }) => {
    if (!getAgoda().isInternalUser) return null;

    return (
        <Box maxWidth="848px" width="100%">
            <TextareaV3
                label={{
                    text: "Error stack",
                }}
                textarea={{
                    rows: 10,
                    value: instance.stack,
                }}
                isReadOnly
            />
        </Box>
    );
};
